export default "__VITE_ASSET__de347450__"